import { render } from "./profileImage.vue?vue&type=template&id=6b3f28b0"
import script from "./profileImage.vue?vue&type=script&lang=js"
export * from "./profileImage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__